var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',[_c('b-tab',[_c('template',{slot:"title"},[_c('i',{staticClass:"icon-list"})]),_c('div',{staticClass:"sidebar tab-sidebar"},[_c('SidebarNav',{attrs:{"navItems":_vm.nav}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }